export default __webpack_public_path__ + "static/media/check_black.7facaa78.svg";